import { takeLatest, put, call } from 'redux-saga/effects';
import { actionTypes as applicationActions } from '../core/reducers/asyncServerResponseReducer';
import { spinResponseService } from './../gameservice/spinResponseService';

export function* spinSaga(): Generator<any, any, any> {
  yield takeLatest(applicationActions.GET_APPLICATION_SPIN_RESPONSE, fireSpinResponse);
}



let spincount: number = 0
function* fireSpinResponse(): Generator<any, any, any> {
  try {
    let result_spin = yield call(spinResponseService.sendSpinResponse);

    //localStorage.setItem("cheatModifiedRequest", "")
    // result_spin = JSON.parse(result_spin.response);
    yield put({
      type: applicationActions.GET_APPLICATION_SPIN_SUCCESS,
      result_spin
    });

  } catch (error) {
    yield put({
      type: applicationActions.GET_APPLICATION_SPIN_FAILURE,
      error
    });
  }
}
function* fireSpinResponse_(): Generator<any, any, any> {
  try {

    let result_spin =
    {
      "data": {
        "response": {
          "bet": {
            "stake": 1.0,
            "stakePerLine": 0.05,
            "balance": "1.00000101545E9",
            "addBalance": 0.0,
            "lines": 20,
            "settle": false,
            "buyIn": false
          },
          "results": {
            "win": {
              "total": 0,
              "symbolWin": {
                "coins": 0,
                "symbols": []
              },
              "scatterWin": {
                "coins": 0,
                "scatters": [{
                  "smbID": 11,
                  "amt": 0,
                  "num": 4,
                  "type": "FREESPIN",
                  "bonusWon": "FREESPINS",
                  "bonusWonValue": 12
                }]
              }
            },
            "reels": [[{
              "smbID": 11,
              "animate": true
            }, {
              "smbID": 1
            }], [{
              "smbID": 11,
              "animate": true
            }, {
              "smbID": 5
            }, {
              "smbID": 5
            }], [{
              "smbID": 11,
              "animate": true
            }, {
              "smbID": 4
            }, {
              "smbID": 4
            }, {
              "smbID": 0
            }], [{
              "smbID": 11,
              "animate": true
            }, {
              "smbID": 6
            }, {
              "smbID": 0
            }, {
              "smbID": 0
            }, {
              "smbID": 7
            }], [{
              "smbID": 10
            }, {
              "smbID": 2
            }, {
              "smbID": 2
            }, {
              "smbID": 2
            }, {
              "smbID": 2
            }, {
              "smbID": 6
            }], [{
              "smbID": 2
            }, {
              "smbID": 2
            }, {
              "smbID": 9
            }, {
              "smbID": 7
            }, {
              "smbID": 4
            }, {
              "smbID": 4
            }, {
              "smbID": 8
            }]]
          },
          "horizontalReel": [[{
            "smbID": 0
          }, {
            "smbID": 8
          }, {
            "smbID": 5
          }, {
            "smbID": 4
          }]],
          "state": {
            "reelSet": "FreespinsReels",
            "status": "FREESPINS_TRIGGER",
            "tumble": false,
            "horizTumble": false,
            "preMult": 1,
            "totalFSAwarded": 2,
            "freespinsRemaining": 2,
            "wonAdditionalSpins": 0,
            "totalWin": 0,
            "coinCountTumble": 0,
            "numTumbles": 0,
            "reelHeights": [2, 3, 4, 5, 6, 7],
            "mult": 1,
            "feature": null,
            "hasCapped": false,
            "anticipate": [3, 4, 5]
          }
        }
      }
    }

    //localStorage.setItem("cheatModifiedRequest", "")
    yield put({
      type: applicationActions.GET_APPLICATION_SPIN_SUCCESS,
      result_spin
    });

  } catch (error) {
    yield put({
      type: applicationActions.GET_APPLICATION_SPIN_FAILURE,
      error
    });
  }
}

